import { AlertReason } from "../models/entities/alert.model";
import { UseMyAlertsResult, useMyAlerts } from "./useMyAlerts";

/**
 * The logged-in user's unresolved consent tasks (task type CONSENT, reason "Consent":
 * telehealth consent Prospective LOW / Active HIGH, ToS + PP HIGH), for the Home
 * worklist (KAN-2647).
 *
 * Reads the SAME `/api/tasks/` rows as Requires attention and critical alerts,
 * so a resolve from any surface refreshes this hook's shared query keys; it is
 * assignee == me unconditionally.
 *
 * Kept as its own module so tests can mock it independently.
 */
export const useMyConsentTasks = (assigneeId: number | undefined | null): UseMyAlertsResult =>
	useMyAlerts(assigneeId, AlertReason.CONSENT);
